import SectionHeading from "./SectionHeading";
import { timelineRows } from "@/mocks/home";

export default function TimelineSection() {
  return (
    <section id="timeline" className="w-full bg-foreground-950 py-16 md:py-24 scroll-mt-20">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="审核时长"
          tone="light"
          title="不同线索类型，审核与发布时间对照"
          desc="下表为常规情况下的处理节奏。遇到突发公共事件，发布可能提前；涉及多方核实的，会适当延长。"
        />

        <div className="mt-12 hidden md:block rounded-lg border border-foreground-800 overflow-hidden">
          <table className="w-full border-collapse text-sm">
            <thead>
              <tr className="bg-foreground-900 text-background-100">
                <th scope="col" className="text-left font-medium px-6 py-4">线索类型</th>
                <th scope="col" className="text-left font-medium px-6 py-4">初审时长</th>
                <th scope="col" className="text-left font-medium px-6 py-4">复核时长</th>
                <th scope="col" className="text-left font-medium px-6 py-4">预计发布</th>
              </tr>
            </thead>
            <tbody>
              {timelineRows.map((row) => (
                <tr
                  key={row.type}
                  className="border-t border-foreground-800 bg-foreground-950 hover:bg-foreground-900/70 transition-colors"
                >
                  <th scope="row" className="text-left font-medium px-6 py-4 text-background-50">
                    <span className="inline-flex items-center gap-2">
                      {row.level === "sensitive" ? (
                        <i className="ri-alarm-warning-line text-accent-400"></i>
                      ) : (
                        <i className="ri-file-text-line text-primary-400"></i>
                      )}
                      {row.type}
                    </span>
                  </th>
                  <td className="px-6 py-4 text-background-100/85">{row.first}</td>
                  <td className="px-6 py-4 text-background-100/85">{row.review}</td>
                  <td className="px-6 py-4">
                    <span
                      className={`inline-flex items-center px-3 py-1.5 rounded-full text-xs font-medium ${
                        row.level === "sensitive"
                          ? "bg-accent-500/20 text-accent-300"
                          : "bg-primary-500/20 text-primary-300"
                      }`}
                    >
                      {row.publish}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-10 md:hidden flex flex-col gap-4">
          {timelineRows.map((row) => (
            <article key={row.type} className="p-5 rounded-lg bg-foreground-900 border border-foreground-800">
              <h3 className="font-heading font-bold text-base text-background-50 flex items-center gap-2">
                {row.level === "sensitive" ? (
                  <i className="ri-alarm-warning-line text-accent-400"></i>
                ) : (
                  <i className="ri-file-text-line text-primary-400"></i>
                )}
                {row.type}
              </h3>
              <dl className="mt-3 space-y-2 text-sm">
                <div className="flex justify-between gap-4">
                  <dt className="text-background-100/60">初审时长</dt>
                  <dd className="text-background-100">{row.first}</dd>
                </div>
                <div className="flex justify-between gap-4">
                  <dt className="text-background-100/60">复核时长</dt>
                  <dd className="text-background-100">{row.review}</dd>
                </div>
                <div className="flex justify-between gap-4">
                  <dt className="text-background-100/60">预计发布</dt>
                  <dd className="text-accent-300 font-medium">{row.publish}</dd>
                </div>
              </dl>
            </article>
          ))}
        </div>

        <p className="mt-8 text-sm text-background-100/60 flex items-start gap-2">
          <i className="ri-information-line mt-0.5"></i>
          以上时长均为自然日口径，不含法定节假日；工作时段指每日 9:00–21:00。
        </p>
      </div>
    </section>
  );
}